var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"show":true,"placement":_vm.placement,"target":_vm.target,"triggers":"manual","custom-class":"free-months-tooltip","noninteractive":true,"title":_vm.$t('subscription.two-month-free')}})}
var staticRenderFns = []

export { render, staticRenderFns }